import React, { useMemo, useRef } from "react";
import { Dialog, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-enterprise";
import { appSettings } from "../../config/appSetting";
import CustomLoadingOverlay from "../CustomLoadingOverlay/CustomLoadingOverlay ";

interface PreflightModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: any;
  title: string;
  preworkFullView: any
}

const DashboardModal: React.FC<PreflightModalProps> = ({
  isOpen,
  onClose,
  data,
  preworkFullView,
  title,
}) => {
  const gridRef = useRef<AgGridReact>(null);
  const pageSizeSelector = appSettings.agGridPageSizeSelector;
  const defaulPageSize = appSettings.agGridDefaulPageSize;
  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    enableRowGroup: true,
  };

  const columnDefs = useMemo<ColDef[]>(() => {
    const baseColumns: ColDef[] = [
      {
        headerName: "#",
        width: 70,
        sortable: false,
        filter: false,
        resizable: false,
        colId: "rowIndex",
        valueGetter: (params) => {
          return params.node ? (params.node.rowIndex ?? 0) + 1 : 0;
        },
      },
      {
        headerName: "Document ID",
        field: "preWorkDocumentID",
        tooltipField: "preWorkDocumentID",
        width: 180,
        colId: "preWorkDocumentID",
        valueGetter: (params) => {
          return params.data?.preWorkDocumentID || params.data?.projectDocumentId || "";
        },
      },
      {
        headerName: "Status",
        field: "status",
        tooltipField: "status",
        width: 200,
        colId: "status",
        flex: 1,
      },
    ];
    if (preworkFullView.dashboardType === 3) {
      baseColumns.push(
        {
          headerName: "File Received",
          field: "preworkReceived",
          tooltipField: "preworkReceived",
          width: 180,
          colId: "preworkReceived",
        },
        {
          headerName: "Export to Preflight",
          field: "preworkPreflight",
          tooltipField: "preworkPreflight",
          width: 200,
          colId: "preworkPreflight",
        },
        {
          headerName: "Preflight Return",
          field: "preworkPreflightReturn",
          tooltipField: "preworkPreflightReturn",
          width: 180,
          colId: "preworkPreflightReturn",
        },
        {
          headerName: "Moved to Final",
          field: "preworkFinal",
          tooltipField: "preworkFinal",
          width: 200,
          colId: "preworkFinal",
        }
      );
    }
  
    return baseColumns;
  }, [preworkFullView.dashboardType]);
  
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          backgroundColor: "var(--aggrid-primary-color)",
          color: "var(--aggrid-text-color)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "35px",
        }}
      >
        {title}
        <IconButton
          data-testid="dashboard-modal-close"
          onClick={onClose}
          sx={{ color: "white" }}
        >
          <CloseIcon style={{ color: "var(--aggrid-text-color)" }} />
        </IconButton>
      </DialogTitle>
      <div className="rp-main-inner col-sm-12">
        <div className="queue-table-view clearfix">
          <div
            className="ag-theme-quartz-dark"
            style={{
              height: "72vh",
              marginTop: ".1vh",
              width: "100%",
            }}
          >
            <AgGridReact
              columnDefs={columnDefs}
              rowData={data}
              pagination={true}
              paginationPageSize={defaulPageSize}
              paginationPageSizeSelector={pageSizeSelector}
              rowGroupPanelShow="always"
              pivotPanelShow="always"
              gridOptions={{
                rowSelection: { 
                  mode : "multiRow",
                  enableClickSelection: false,
                 },  
              }}
              defaultColDef={defaultColDef}
              ref={gridRef}
              loading={!data}
              loadingOverlayComponent={CustomLoadingOverlay}
              overlayNoRowsTemplate={
                '<span class="ag-overlay-loading-center">No rows to show</span>'
              }
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
};
export default DashboardModal;
